export const MediaSmall = '(max-width: 736px)'
export const NotMediaSmall = '(min-width: 737px)'
export const MediaMobile = '(max-width: 425px)'
export const NotMediaMobile = '(min-width: 426px)'

export const MaxMediaWidth = {
  mobile: 425,
  small: 736,
}
